import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this ebook really for absolute beginners?',
  a: 'Yes. The K-Smart Visual System is designed for people who have never studied Korean or any other language. We start from the alphabet and build everything step by step.'
}, {
  q: "Can I learn even if I don't have a good language foundation?",
  a: 'Absolutely. Korean is actually easier than most European languages because it has a logical, phonetic alphabet (Hangul) and predictable grammar rules. The visual method works for everyone.'
}, {
  q: 'Are the phrases and expressions actually useful, or just examples?',
  a: '100% useful. Every phrase in this system comes from real K-Dramas, K-Pop lyrics and actual conversations Korean people have. You will recognize these phrases immediately when watching or talking to Koreans.'
}, {
  q: 'Does the ebook include pronunciation guidance and tips to avoid mistakes?',
  a: 'Yes. It includes detailed pronunciation guides, the common mistakes English speakers make and specific drills to fix your accent. Plus, the Discord community has native Korean speakers to help.'
}, {
  q: 'How soon will I see real progress?',
  a: 'By day 7 you will read and write Hangul confidently. By day 14 you will understand basic conversations. By day 30 you will catch 30-40% of K-Drama dialogue without subtitles and have your first real conversation in Korean.'
}, {
  q: 'Do I need other apps or can I just use this system?',
  a: 'This system is complete on its own. We do recommend combining it with Netflix (K-Dramas) and Spotify (K-Pop) as immersion tools. The Discord community also connects you with language partners for practice.'
}, {
  q: "What if I don't have 90 minutes every day?",
  a: 'Start with 30 minutes. The system is flexible. 30 minutes daily is more effective than 3 hours once a week — consistency beats intensity.'
}, {
  q: 'Is there support if I get stuck?',
  a: 'Yes. The K-Smart Inner Circle Discord has mentors, native speakers and a community that supports each other. You are never alone in this.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-57" data-mp="2ay0obrj7my7c">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-58" data-mp="2avwc8mb5qsvz">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-59" data-mp="33meniam1c0kh">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-60" data-mp="2ym0eoqcm0mle">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-61" data-mp="1n8epj56r2kzv" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-62" data-mp="1n9prczgmxioc">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-63" data-mp="2qney2p0m6zj">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-64" data-mp="7nnmyj5fdjta" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-65" data-mp="cfnje1madul4" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-66" data-mp="hfa3mv0j8b3f">
                  <div className="overflow-hidden" data-id="element-67" data-mp="mg7ndc16xd71">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-68" data-mp="qfggceoep71j">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}